import { render, staticRenderFns } from "./macher-job-fair.vue?vue&type=template&id=00b930b8&scoped=true&"
import script from "./macher-job-fair.vue?vue&type=script&lang=js&"
export * from "./macher-job-fair.vue?vue&type=script&lang=js&"
import style0 from "./macher-job-fair.vue?vue&type=style&index=0&id=00b930b8&prod&lang=scss&scoped=true&"
import style1 from "./macher-job-fair.vue?vue&type=style&index=1&id=00b930b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b930b8",
  null
  
)

export default component.exports